import { InfoCircleFilled } from "@ant-design/icons";
import { Divider, Popover } from "antd";
import { FC } from "react";
import { IProductPrice } from "types/product";

interface IWholesaleInfoBadge {
  priceList: IProductPrice[];
  unit: string;
}
const renderPriceListItem = (priceItem: IProductPrice, unit: string) => {
  let qtyLabel = `${priceItem.minQuantity} ${unit || ""} ขึ้นไป`;
  if (priceItem.maxQuantity) {
    qtyLabel = `${priceItem.minQuantity} - ${priceItem.maxQuantity} ชิ้น`;
  }
  return (
    <div className="flex gap-4">
      <small>{qtyLabel}</small>
      <small>ราคา {priceItem.price} บาท</small>
    </div>
  );
};
const WholesaleInfoBadge: FC<IWholesaleInfoBadge> = ({ priceList, unit }) => {
  if (!priceList || priceList.length === 1) {
    return <div className="h-[24px]" />;
  }

  return (
    <Popover
      content={() => {
        return (
          <div className="p-2 flex flex-col gap-1">
            <Divider className="mt-0 mb-2" />
            {priceList
              .sort((a, b) => (a.minQuantity || 0) - (b.minQuantity || 0))
              .map((price) => {
                return (
                  <div key={price.id}>{renderPriceListItem(price, unit)}</div>
                );
              })}
          </div>
        );
      }}
      title={<div className="text-center">ซื้อเยอะถูกลง</div>}
      placement="right"
    >
      <div className="bg-[#E8F8CCE8] rounded-3xl flex px-2 py-1 gap-1 text-xs cursor-pointer w-[100px]">
        <div className="text-[#527F00]">ซื้อเยอะถูกลง</div>
        <div>
          <InfoCircleFilled style={{ color: "#568504" }} />
        </div>
      </div>
    </Popover>
  );
};

export default WholesaleInfoBadge;
